module.exports = __webpack_public_path__ + "img/utilityheavy_parked.81639c7e.svg";